<script>
    /*
    	RemoveResourceButton.svelte
    */

    import { onMount } from 'svelte';

    // TCARE components

    // SMUI components

    const SVG_IMAGE_PATH   = '/img/garbage_can.svg';

    export let onClick;

    onMount(() => {
    })

</script>

<style>

    .remove-resource-button button {
        padding: 10px 15px 10px 15px;
        font-size: 15px;
        color: var(--tcui-primary);
        background-color: #DFCDD8;
        border-radius: 16px;
        border: none;
    }

    .remove-resource-button button:hover {
        color: white;
        background-color: var(--tcui-secondary);
    }

    .remove-resource-button .button-content {
        display: flex;
        align-items: center;
    }

    /*
    .remove-resource-button .button-content img {
        margin-left: 6px;
    }
    */

    .remove-resource-button svg {
        width: 16px;
        height: 16px;
        margin-left: 6px;
        fill: none;
    }

    .remove-resource-button:hover svg path {
        stroke: white;
    }



    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="remove-resource-button">
    <button on:click={onClick}>
        <div class="button-content">
            Remove
            <!-- <img src={SVG_IMAGE_PATH} alt={'Remove Resource'} draggable="false" > -->
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.75 3.5H2.91667H12.25" stroke="#611C73" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M4.6665 3.49999V2.33332C4.6665 2.0239 4.78942 1.72716 5.00821 1.50837C5.22701 1.28957 5.52375 1.16666 5.83317 1.16666H8.1665C8.47592 1.16666 8.77267 1.28957 8.99146 1.50837C9.21025 1.72716 9.33317 2.0239 9.33317 2.33332V3.49999M11.0832 3.49999V11.6667C11.0832 11.9761 10.9603 12.2728 10.7415 12.4916C10.5227 12.7104 10.2259 12.8333 9.9165 12.8333H4.08317C3.77375 12.8333 3.47701 12.7104 3.25821 12.4916C3.03942 12.2728 2.9165 11.9761 2.9165 11.6667V3.49999H11.0832Z" stroke="#611C73" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M5.8335 6.41667V9.91667" stroke="#611C73" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8.1665 6.41667V9.91667" stroke="#611C73" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>                            
        </div>
    </button>
</div>
